import { baseUrl } from '@/api/http.js'
import axios from '../api/config'
const API_BASE = baseUrl
// const API_BASE = '' //Vue.config.js 里跨域处理所需要地址

export default {
  // 乡镇数据
  townsData(data) {
    return axios.post(`${API_BASE}/api/Index/townsData`, data)
  },
  // 全县快递量
  CountyExpress(data) {
    return axios.post(`${API_BASE}/api/Index/CountyExpress`, data)
  },
  //截止昨日年度快递总量/昨日快递总量
  YesterDayOrBeforeExpressTotal(data) {
    return axios.post(`${API_BASE}/api/Index/YesterDayOrBeforeExpressTotal`, data)
  },
  //查询
  SellDate(data) {
    return axios.post(`${API_BASE}/api/Index/SellDate`, data)
  },
  //查询
  SellDate(data) {
    return axios.post(`${API_BASE}/api/Index/SellDate`, data)
  },
  //天气
  GetWeather(data) {
    return axios.post(`${API_BASE}/api/Index/GetWeather`, data)
  },
  //今日快递总量
  ThisDayData(data) {
    return axios.post(`${API_BASE}/api/Index/ThisDayData`, data)
  },
}
